<template>
  <div v-if="getClientByid(resa.cid)" class="resaline"
    :class="[{ 'resaline-cancelled': resaCurrentState === 'CANCELLED' }, { 'print-ok': resaCurrentState !== 'TO_CONFIRM' }]"
    :id="(resaCurrentState !== 'TO_CONFIRM') ? 'printOk' : ''">
    <el-row :gutter="0" class="resaline-row">
      <el-col :span="5">
        <div class="resaline-item resaline-time">
          {{ resa.hour }}
        </div>
      </el-col>
      <el-col v-if="resa.room !== ''" class="resaline-hide"> - {{ getRoomName(resa.room) }} </el-col>
      <el-col class="resaline-hide"> - {{ getClientByid(resa.cid).civ }} </el-col>
      <el-col :span="10">
        <div class="resaline-item resaline-name">
          <div class="resaline-item-name">
            <span v-if="resa.preFix && resa.preFix !== ''">
              {{ resa.preFix.slice(0, 4) }} .
            </span>
            <span class="resaline-name-main">
              {{ maxChar(getClientByid(resa.cid).name, 13) }}
            </span>
            {{ maxChar(getClientByid(resa.cid).prenom, 14) }}
          </div>
          <div class="resaline-labels">
            <client-tag v-for="tag in [...getClientByid(resa.cid).tags].sort()" :key="tag" :idTag="tag"
              :deletable="false" :cid="resa.cid">
            </client-tag>
          </div>
          <div class="resaline-tags">
            <div v-if="resa.discount" class="resaline-tag resaline-tag-discount">
              <p>-{{ resa.discount }}%</p>
            </div>
            <div v-if="resa.allergen" class="resaline-tag" :class="'resaline-tag-allergen'"></div>
            <div class="resaline-tag" :class="'resaline-tag-' + resa.source.toLowerCase()"></div>
            <div v-if="resa.commentResa && resa.commentResa !== ''" class="resaline-tag resaline-tag-havecomment">
              <div class="resaline-tag resaline-tag-havecomment-icon"></div>
            </div>
            <div class="resaline-tag" v-if="getClientByid(resa.cid).countShow > 0">
              <div class="resaline-tag resaline-tag-countstar" v-if="getClientByid(resa.cid).countShow > 1">
                {{ getClientByid(resa.cid).countShow }}</div>
              <div class="resaline-tag resaline-tag-star">
                <div class="resaline-tag-star-icon"></div>
              </div>
            </div>
            <div class="resaline-tag" v-if="getClientByid(resa.cid).countNoShow > 0">
              <div class="resaline-tag resaline-tag-countnoshow" v-if="getClientByid(resa.cid).countNoShow > 1">
                {{ getClientByid(resa.cid).countNoShow }}</div>
              <div class="resaline-tag resaline-tag-noshow">
                <div class="resaline-tag-noshow-icon"></div>
              </div>
            </div>
            <div class="resaline-tag-cash"
              v-if="resa.type && resa.type !== undefined && resa.type !== '' && resa.amount > 0">
              <span :class="'resaline-tag-cash-' + resaPayementColorState">
                <span v-if="resa.type === 'caution'">C</span>
                <span v-else>P</span>
                : <span v-if="resa.total">{{ resa.total }}</span><span v-else>{{ Math.round((resa.amount *
                  resa.nbCouvert)
                  * 100) / 100 }}</span>€
              </span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="resaline-hide"> (</el-col>
      <el-col :span="4">
        <div class="resaline-item resaline-nbCouvert">
          {{ resa.nbCouvert }}
        </div>
      </el-col>
      <el-col class="resaline-hide">)</el-col>
      <el-col class="resaline-hide" v-if="getClientByid(resa.cid).countShow > 0">
        <div style="margin-left:5px">- {{ getClientByid(resa.cid).countShow }} Show</div>
      </el-col>
      <el-col class="resaline-hide" v-if="getClientByid(resa.cid).countNoShow > 0">
        <div style="margin-left:5px">- {{ getClientByid(resa.cid).countNoShow }} NoShow</div>
      </el-col>
      <el-col class="resaline-hide" v-if="getClientByid(resa.cid).tel && getClientByid(resa.cid).tel !== ''"> -
        {{ formatPhone(getClientByid(resa.cid).tel, getClientByid(resa.cid).telPreFix) }}</el-col>
      <!-- TODO: Check resa state -->
      <el-col :span="5" class="resaline-state resaline-col resaline-col-dark"
        :class='{ "resaline-col-selected": resaSwicthSelected, "resaline-col-selected_target": getIsSwitchTarget }'>
        <div class="resaline-col-container" @click="openResa">
          <div :class="['resaline-state-new', (resa.newState) ? '' : 'resaline-state-new-hide']">new</div>
          <!-- TODO: refactor this dom line resa state -->
          <div v-if="resaCurrentState === 'TO_CONFIRM'" class="resaline-state-unvalidate">
            <div class="resaline-state-unvalidate-content">
              <div class="resaline-state-unvalidate-icon"></div>
            </div>
          </div>
          <div v-if="resaCurrentState === 'NEED_TABLE'" class="resaline-state-untabled">
            <div class="resaline-state-untabled-content">
              <div class="resaline-state-untabled-icon"></div>
            </div>
          </div>
          <div v-if="resaCurrentState === 'NO_SHOW'" class="resaline-state-noshow">
            <div class="resaline-state-noshow-content">
              <div class="resaline-state-noshow-icon"></div>
            </div>
          </div>
          <div v-if="resaCurrentState === 'CANCELLED' && this.resa.modify" class="resaline-state-cancelled-m">
            <div class="resaline-state-cancelled-m-icon"></div>
          </div>
          <div v-if="resaCurrentState === 'CANCELLED' && !this.resa.modify" class="resaline-state-cancelled">
            <div class="resaline-state-cancelled-icon"></div>
          </div>
          <div v-if="resaCurrentState === 'DONE' || (resaCurrentState === 'SHOW' && resa.tids.length === 0)"
            class="resaline-state-done">
            <div class="resaline-state-noshow-content">
              <div class="resaline-state-done-icon"></div>
            </div>
            <div class="resaline-table-id_DONE" v-if="resa.tids.length > 0">{{ resa.tids[0] }}</div>
          </div>
          <div v-if="resaCurrentState === 'CONFIRMED' || resaCurrentState === 'SHOW'" class="resaline-table"
            :class='{ "resaline-table-selected": resaSwicthSelected }'>
            <div class="resaline-table-centered">
              <div v-if="this.resa.tids.length > 1" class="resaline-table-linked">
                <div class="resaline-table-linked-icon"></div>
              </div>
              <div class="resaline-table-id"
                :class='{ "resaline-table-id_SHOW": resaSHOW, "resaline-table-id_LATE": this.resaInLate }'>{{ resaTid }}
              </div>
              <div class="resaline-table-timmer"
                :class='{ "resaline-table-timmer_LATE": this.resaInLate, "resaline-table-timmer_WARN": this.resaWarning }'
                v-if="this.resaTimer !== ''">
                {{ resaTimer }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="resaline-hide" v-if="getAllTablesString !== ''"> - {{ getAllTablesString }}</el-col>
      <el-col class="resaline-hide" v-if="resa.type && resa.type !== undefined && resa.type !== '' && resa.amount > 0">
        <span :class="resaPayementColorState">
          - <span v-if="resa.type === 'caution'">C</span>
          <span v-else>P</span>
          : <span v-if="resa.total">{{ resa.total }}</span><span v-else>{{ Math.round((resa.amount * resa.nbCouvert) *
            100)
            / 100 }}</span>€
        </span>
      </el-col>
      <el-col class="resaline-hide" v-if="resa.allergen">
        <div style="margin-left:10px"> - allergène / intolérance : {{ resa.allergenMessage }} </div>
      </el-col>
      <el-col class="resaline-hide" v-if="resa.commentResa && resa.commentResa !== ''">
        <div style="margin-left:10px"> -> {{ resa.commentResa }}</div>
      </el-col>
    </el-row>
    <div class="resaline-separator">
      <div class="resaline-hide" style="width:100%; border-bottom:1px dashed black; margin:10px 0"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as resaState from '../../store/types/resa-state';
import { resaTradCurrentState } from '../../tools/resaTools';
import { compareTime, difTime, difTimeInMinutes, formatTime, nextTime, timeInMinutes } from '../../tools/timeTool';
import ClientTag from '../clients/ClientTag.vue';

export default {
  components: { ClientTag },
  name: 'ResaLine',
  props: {
    resa: {}
  },
  data() {
    return {
      intervalId: null,
      tidPrinted: 0
    }
  },
  computed: {
    ...mapGetters({
      getClientByid: 'newClients/getClientByid',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getLinkedResaIdsToTable: 'newRooms/getLinkedResaIdsToTable',
      getSelectedMainServiceData: 'newServices/getSelectedMainServiceData',
      inCurrentService: 'newServices/inCurrentService',
      getCurrentResaById: 'newReservations/getCurrentResaById',
      getCurrentResaDataTimerById: 'newReservations/getCurrentResaDataTimerById',
      getModSwitchTable: 'newReservations/getModSwitchTable',
      getResaToSwitch1: 'newReservations/getResaToSwitch1',
      getResaToSwitch2: 'newReservations/getResaToSwitch2',
      getRoomName: 'newRooms/getRoomName'
    }),
    resaCurrentState: function () {
      if (this.resa !== null || this.resa !== undefined) return resaTradCurrentState(this.resa.state, this.resa.tids)
    },
    resaSHOW: function () {
      return this.resaCurrentState === 'SHOW'
    },
    resaTid: function () {
      return this.tidPrinted
    },
    resaTimer: function () {
      if (this.getCurrentResaDataTimerById(this.resa.id)) return this.getCurrentResaDataTimerById(this.resa.id).timer
      return ''
    },
    resaWarning: function () {
      if (this.getCurrentResaDataTimerById(this.resa.id)) return this.getCurrentResaDataTimerById(this.resa.id).warningEnd
      return false
    },
    resaInLate: function () {
      if (this.getCurrentResaDataTimerById(this.resa.id)) return this.getCurrentResaDataTimerById(this.resa.id).inLate
      return false
    },
    resaSwicthSelected: function () {
      if (this.getModSwitchTable && ((this.getResaToSwitch1.data !== undefined && this.getResaToSwitch1.data.id === this.resa.id) || (this.getResaToSwitch2.data !== undefined && this.getResaToSwitch2.data.id === this.resa.id))) return true
      return false
    },
    resaPayementColorState: function () {
      if (this.resa.payementDone) return 'green'
      else if (this.resa.payementDone === false) return 'red'
      else return 'white'
    },
    getIsSwitchTarget: function () {
      if (this.getModSwitchTable && ((this.getResaToSwitch1.data !== undefined && this.getResaToSwitch1.data.id === this.resa.id) || (this.getResaToSwitch2.data !== undefined && this.getResaToSwitch2.data.id === this.resa.id))) {
        if (this.getResaToSwitch1.data.id !== this.resa.id) {
          return true
        }
      }
      return false
    },
    getAllTablesString: function () {
      let tmp = ''
      if (!this.resa || !this.resa.tids || !this.resa.tids.length === 0) return ''
      this.resa.tids.forEach((val, index) => {
        tmp += val.toString()
        if (index < this.resa.tids.length - 1) tmp += ' / '
      })
      return tmp
    },
    getResaHour: function () {
      return this.resa.hour
    }
  },
  watch: {
    'resaCurrentState': function (val, oldVal) {
      if (val !== oldVal && (val === 'CONFIRMED' || val === 'SHOW' || val === 'NO_SHOW')) {
        this.updateTimer()
      }
    },
    'getResaHour': function (val, oldVal) {
      if (val && oldVal && val !== oldVal) this.updateTimer()
    },
    'resa': function (val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.setPrintedTids()
      }
    }
  },
  methods: {
    ...mapMutations({
      setSelectedResa: 'newReservations/setSelectedResa',
      setModLinkTable: 'newRooms/setModLinkTable',
      setSelectedTable: 'newRooms/setSelectedTable',
      setSelectedTables: 'newRooms/setSelectedTables',
      setSelectedRoom: 'newRooms/setSelectedRoom',
      setResasTimerInfo: 'newReservations/setResasTimerInfo',
      setResaToSwitch1: 'newReservations/setResaToSwitch1',
      setResaToSwitch2: 'newReservations/setResaToSwitch2'
    }),
    ...mapActions({
      showHidePopupManageServices: 'displayer/showHidePopupManageServices',
      unSelectedTables: 'newRooms/unSelectedTables',
      updateSwitchableResaByResa: 'newReservations/updateSwitchableResaByResa',
      updateNewStateResa: 'newReservations/updateNewStateResa'
    }),
    maxChar: function (name, maxChar) {
      if (name.length > maxChar) return `${name.substring(0, maxChar)}..`
      else return name
    },
    formatPhone: function (phone, phonePreFix) {
      if (phone.length < 3) return null
      if (phonePreFix !== '' && phone[0] !== '+') {
        let p = phone
        if (phone[0] === '0') p = phone.substring(1)
        return phonePreFix + p
      } else if (phone[0] !== '0' && phone[0] !== '+') {
        return `0${phone}`
      }
      return phone
    },
    openResa: function () {
      this.resa.newState = false
      if (this.getModSwitchTable) {
        this.updateSwitchableResaByResa(this.resa)
      } else {
        this.setSelectedResa(this.resa)
        this.showHidePopupManageServices()
        switch (this.resaCurrentState) {
          case resaState.CONFIRMED:
          case resaState.NEED_TABLE:
          case resaState.TO_CONFIRM:
            this.linkTableToSelection()
            this.setModLinkTable(true)
            break
          case resaState.SHOW:
            this.linkTableToSelection()
            break
        }
      }
    },
    linkTableToSelection: function () {
      if (this.resa.room !== '' && this.resa.room !== this.getSelectedRoom) this.setSelectedRoom(this.resa.room)
      this.unSelectedTables()
      if (this.resa.tids !== undefined && this.resa.tids.length > 0) {
        this.resa.tids.forEach((tid) => {
          this.setSelectedTable(tid)
        })
        this.setPrintedTids()
      }
    },
    launchTimer: function () {
      this.clearInterval()
      return window.setInterval(() => {
        this.updateTimer()
      }, 60000)
    },
    clearInterval: function () {
      if (this.intervalId !== null) window.clearInterval(this.intervalId)
    },
    setPrintedTids: function () {
      if (this.resa && this.resa.tids.length > 0) {
        this.tidPrinted = this.resa.tids.sort(function (a, b) {
          return a - b
        })[0]
      }
    },
    updateTimer: function () {
      let resaDataT = {
        id: this.resa.id,
        hour: '',
        timer: '',
        inLate: false,
        warningEnd: false,
        difMinutes: 0
      }
      if (this.resa.tids !== undefined && this.resa.tids.length > 0) {
        if (this.inCurrentService()) {
          let hStartResa = this.resa.hour
          let lenghtService = this.getSelectedMainServiceData.lenghtService
          let hEndResa = nextTime(this.resa.hour, lenghtService)
          let limitSecu = timeInMinutes(this.getSelectedMainServiceData.limitSecuChrono)
          let now = new Date()
          let currentTime = formatTime({
            hours: now.getHours(),
            minutes: now.getMinutes()
          })
          resaDataT.hour = this.resa.hour
          resaDataT.timer = difTime(hStartResa, currentTime)
          resaDataT.difMinutes = difTimeInMinutes(hStartResa, currentTime)
          if (this.resaCurrentState === 'SHOW') {
            resaDataT.timer = ''
            resaDataT.difMinutes = difTimeInMinutes(hEndResa, currentTime)
            // get next hour resa
            let allResaLinked = this.getLinkedResaIdsToTable(this.resa.room, this.resa.tids[0])
            // if exist check limitSecu between arrival next resa if < set warning to true and timer to this dif
            if (allResaLinked.length > 0) {
              let resasAfter = []
              allResaLinked.forEach((rId) => {
                if (this.getCurrentResaById(rId) !== undefined) {
                  let checkedHour = this.getCurrentResaById(rId).hour
                  if (compareTime(checkedHour, this.resa.hour) > 0) {
                    resasAfter.push(checkedHour)
                  }
                }
              })
              if (resasAfter.length > 0) {
                resasAfter.sort((a, b) => {
                  return compareTime(a, b)
                })
                let timeNextArrival = difTimeInMinutes(resasAfter[0], currentTime)
                if (timeNextArrival < limitSecu) {
                  resaDataT.warningEnd = true
                  resaDataT.timer = difTime(resasAfter[0], currentTime)
                }
              }
            }
          } else if (this.resaCurrentState === 'CONFIRMED') {
            if (resaDataT.difMinutes < 0) {
              resaDataT.inLate = true
            } else if (resaDataT.difMinutes >= 0 && resaDataT.difMinutes < limitSecu) {
              this.canBeBooked = false
            } else {
              this.canBeBooked = true
            }
          }
        } else {
          resaDataT.hour = this.resa.hour
          resaDataT.timer = ''
        }
      } else {
        resaDataT.timer = ''
      }
      // update resa
      this.setResasTimerInfo(resaDataT)
    },
    cleanNotifNewState: function () {
      window.removeEventListener('focus', this.cleanNotifNewState)
      setTimeout(() => {
        this.updateNewStateResa(this.resa)
      }, 5000)
    }
  },
  mounted: function () {
    // just upadte new state in bdd
    if (this.resa.newState) {
      if (!window.document.hasFocus()) {
        window.addEventListener('focus', this.cleanNotifNewState)
      } else {
        this.cleanNotifNewState()
      }
    }
  },
  created: function () {
    this.updateTimer()
    // TODO: if (this.resa.state !== resaState.DONE && this.resa.state !== resaState.NO_SHOW)
    this.intervalId = this.launchTimer()
    this.setPrintedTids()
  },
  destroyed: function () {
    this.clearInterval()
  }
}
</script>

<style lang="scss" scoped>
@use "../../styles/components/elements/resaline";

.resaline-tag-cash-red {
  color: var(--color_red)
}

.resaline-tag-cash-green {
  color: var(--color_green)
}

.resaline-tag-discount {
  display: inline-block;
  margin-right: 6px;
  background-color: var(--color_red);
  border-radius: 4px;
  padding: 0 3px;
  height: 18px;

  p {
    color: white;
    line-height: 18px;
    font-size: 14px;
    margin: 0;
  }
}
</style>
